module.exports = __webpack_public_path__ + "img/ic-line-message.712f71ba.svg";